import React, {useEffect, useState} from "react";
import associateServices from "../../../../services";
import Loading from "../../../../components/loading";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Tooltip} from "react-tooltip";
import RankIcon from "../../../../components/rank-icon";
import moment from "moment/moment";
import Big from "big.js";
import InstrumentIcon from "../../../../components/instrument-icon";
import StringHelper from "../../../../helpers/string-helper";

const BonusModal = () => {

    const {t} = useTranslation()
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState({})
    const {selectedWallet} = useSelector(state => state.authenticationReducer)
    const {user} = useSelector(state => state.authenticationReducer)

    useEffect(() => {
        checkBonus(selectedWallet?.code)
    }, [selectedWallet?.code])

    const checkBonus = (code) => {
        setLoading(true)
        associateServices.checkUserHasActiveBonus({
            code
        }).then(res => {
            setLoading(false)

            if (res?.data?.id) {

                res.data.percentage = Big(res?.data?.current || 0).div(res?.data?.required || 1).times(100).toFixed(2)

                setData(res?.data || {})
            }
        })
    }


    return (
        <div>
            {
                loading ? <Loading/> :
                    <div className="progress-wrapper home-progress">
                        <div className="modal__profile">

                            <div className="w-100 d-flex align-self-center justify-content-between">
                                <div className="d-flex align-self-center justify-content-center">
                                    <div className="modal__icon">
                                        <InstrumentIcon code={data?.bonus?.currency}/>
                                    </div>
                                </div>


                                <div className="modal__user">
                                    <span
                                        className="text-secondary">{t('modals.vip.bonus.date')}: {moment.unix(data?.timestamp).format("MMM Do YY")}</span>
                                    <span
                                        className="text-secondary">{t('modals.vip.bonus.type')}: {StringHelper.capitalizeFirstLetter(data?.bonus?.model)}</span>
                                    <span
                                        className="text-secondary">{t('modals.vip.bonus.balance')}: {Big(data?.bonus?.balance || 0).toFixed(2)} USDT</span>
                                </div>
                            </div>

                        </div>

                        <div className="modal__progress">
                            <div className="modal__progress-text">
                                <div>
                                    <span className="text-secondary">{t('modals.vip.bonus.amount')}: </span>
                                    <span>{Big(data.amount || 0).toFixed(2)} {data?.bonus?.currency}</span>
                                </div>
                                <span>{Big(data?.percentage || 0).toFixed(2)}%</span>
                            </div>
                            <div className="modal__progress-bar">
                                <span style={{width: `${parseInt(data?.percentage || 0)}%`}}/>
                            </div>


                            <div className="modal__progress-text modal__progress-text--white small">

                                <p className="d-flex align-items-center gap-2">
                                    <span className="text-secondary">{t('modals.vip.bonus.wager')}: </span>
                                    {Big(data?.current || 0).toFixed(3)} {data?.bonus?.currency}
                                </p>


                                <p className="d-flex align-items-center gap-2">
                                    <span className="text-secondary">{t('modals.vip.bonus.required')}: </span>
                                    {Big(data?.required || 0).toFixed(3)} {data?.bonus?.currency}
                                </p>


                            </div>
                        </div>
                    </div>

            }


        </div>
    )

}


export default BonusModal
